import axios from 'axios'
import { host } from '../../helper/config'
import { FULL_LIST_ITEM_PER_PAGE, getItemPerPage } from '../../helper/helper'

const PLUGINS_NAME = 'admin-tickets'

export const getList = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-list`, {
        ...query,
        page: page,
        itemPerPage: getItemPerPage()
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const getCsv = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-csv`, {
        ...query,
        page: page,
        itemPerPage: FULL_LIST_ITEM_PER_PAGE
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const getRevenueStatistics = async (token, query) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-revenue-statistics`, query, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const updateTicketImages = async (token, ticketId, images) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/update-images`, {
        ticketId,
        images
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const updatePeriodTicket = async (token, ticketId, oldPeriodId, newPeriodId) => {
    try {
        if (oldPeriodId === newPeriodId) {
            return false
        }
        const response = await axios.post(`${host}/${PLUGINS_NAME}/update-ticket-period`, {
            ticketId: ticketId,
            oldPeriodId: oldPeriodId,
            newPeriodId: newPeriodId
        }, {
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Content-Type': 'application/json',
                'Authorization': token
            },
        })
    
        if (response && response.status === 200) {
            return true
        }
        return false
    } catch (error) {
        return false
    }
}

export const getIssueList = async (token, query, page) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/get-issue-list`, {
        ...query,
        page: page,
        itemPerPage: getItemPerPage()
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}

export const deleteTicket = async (token, ticketId) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/delete-ticket`, {
        ticketId: ticketId
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return null
}
